<p>az-edit-speakers works!</p>
